module.exports = __webpack_public_path__ + "static/media/recording_success.c3a7b7e8.png";